<template>
  <div class="deviceStatesTable">
    <div class="table-title">设备状态</div>
    <el-table
      :data="deviceStates"
      :cell-class-name="tableCellClassName"
      max-height="450"
      size="mini"
      stripe border>
      <el-table-column
        min-width="250"
        prop="deviceName"
        label="孔号">
        <template slot-scope="scope">
          <el-link @click="navigateToProfile(scope.row)">
            <i class="el-icon-search"></i>
            {{displayName(scope.row)}}
          </el-link>
        </template>
      </el-table-column>

      <!-- 补丁 @20200204 NB设备网络状态跟采集状态一致 -->
      <el-table-column
        width="80"
        label="网络状态">
        <template slot-scope="scope">
          <span>{{stateContent(scope.row)}}</span>
        </template>
      </el-table-column>

      <el-table-column
        width="80"
        label="采集状态">
        <template slot-scope="scope">
          <span>{{stateContent(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="stateFormatter"
        prop="exceedState"
        width="200"
        label="告警状态">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  HDA2, HDA3, HDA4,
  HDA5, HDA6, HDA7, HDA8,
} from '@/utils/constants';

export default {
  props: ['deviceStates'],
  computed: {
    ...mapState('project', ['projects']),
    ...mapGetters('admin', ['fakeState']),
  },
  methods: {
    stateFormatter(row, column, cellValue) {
      return cellValue ? '正常' : '异常';
    },
    tableCellClassName({ row, column }) {
      if (column.label === '孔号') {
        return '';
      }
      if (this.fakeState) {
        return 'success-cell';
      }
      if (column.label === '网络状态' && row.collectState) {
        return 'success-cell';
      }
      if (column.label === '采集状态' && row.collectState) {
        return 'success-cell';
      }
      if (column.label === '告警状态') {
        return row.exceedState ? 'success-cell' : 'danger-cell';
      }
      return 'warning-cell';
    },
    navigateToProfile(row) {
      const project = this.projects.find(p => p.id === row.projectId);
      this.$store.dispatch('project/changeProject', { project });
      if (row.type === HDA2) {
        this.$router.push({ name: 'hda2-chart', params: { deviceId: row.name } });
      }
      if (row.type === HDA3) {
        this.$router.push({ name: 'hda3-chart', params: { deviceId: row.name } });
      }
      if (row.type === HDA4) {
        this.$router.push({ name: 'hda4-chart', params: { deviceId: row.name } });
      }
      if (row.type === HDA5) {
        this.$router.push({ name: 'hda5-chart', params: { deviceId: row.name } });
      }
      if (row.type === HDA6) {
        this.$router.push({ name: 'hda6-chart', params: { deviceId: row.name } });
      }
      if (row.type === HDA7) {
        this.$router.push({ name: 'hda7-chart', params: { deviceId: row.name } });
      }
      if (row.type === HDA8) {
        this.$router.push({ name: 'hda8-chart', params: { deviceId: row.name } });
      }
    },
    displayName(row) {
      if (row.Branch && row.Branch.name) {
        return `${row.Branch.name} / ${row.deviceName}`;
      }
      return row.deviceName;
    },
    // 采集状态与网络状态显示一致，以采集状态为准
    stateContent(row) {
      if (this.fakeState) return '正常';
      return row.collectState ? '正常' : '异常';
    },
  },
};
</script>
<style lang="scss">
.deviceStatesTable{
  .el-table__row{
    td{
      padding: 5px;
    }
  }
}
</style>
